<div class="llm-panel">
  <div class="llm-panel__head">
    <div>
      <h3 class="llm-panel__title">{{ 'Kunden mit eigenem Zugang' | translate }}</h3>
      <div class="llm-panel__hint">
        {{ 'Diese Kunden nutzen eigene Zugangsdaten und werden nicht über nextPIM abgerechnet' | translate }}
      </div>
    </div>

    <div class="llm-panel__tools">
      <span class="llm-count">
        {{ visibleCount }}<ng-container *ngIf="isFiltered"> / {{ access.length }}</ng-container>
      </span>
      <dx-text-box
        [width]="240"
        mode="search"
        valueChangeEvent="input"
        placeholder="{{ 'Kunde suchen' | translate }}"
        (onValueChanged)="onSearch($event)"
      ></dx-text-box>
    </div>
  </div>

  <dx-data-grid
    [dataSource]="access"
    [showBorders]="true"
    [rowAlternationEnabled]="true"
    [columnAutoWidth]="true"
    noDataText="{{ 'Kein Kunde nutzt eigene Zugangsdaten' | translate }}"
    keyExpr="id"
    (onContentReady)="onContentReady($event)"
  >
    <dxo-paging [enabled]="false"></dxo-paging>

    <dxi-column dataField="customerName" caption="{{ 'Kunde' | translate }}"></dxi-column>
    <dxi-column dataField="provider" caption="{{ 'Anbieter' | translate }}" [width]="180">
      <dxo-lookup [dataSource]="providers" displayExpr="name" valueExpr="id"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="baseUrl" caption="{{ 'Eigene URL' | translate }}" cellTemplate="urlTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'urlTemplate'">
      <span *ngIf="cell.value">{{ cell.value }}</span>
      <span *ngIf="!cell.value" class="llm-muted">{{ 'Standard-URL des Anbieters' | translate }}</span>
    </div>
    <dxi-column dataField="isDefault" caption="{{ 'Standard des Kunden' | translate }}" [width]="170" dataType="boolean"></dxi-column>
  </dx-data-grid>
</div>
